import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary } = theme.palette;

  return {
    commentRoot: {
      borderBottom: "1px solid #eee"
    },
    headerRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontWeight: 500,
      height: 22,
      color: primary.main,
      marginBottom: 6
    },
    row: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: 12,
      color: primary.dark,
      marginBottom: 5
    },
    commenterInfo: {
      display: "flex",
      alignItems: "center"
    },
    info: {
      display: "flex",
      textTransform: "capitalize"
    },
    icon: {
      width: 13,
      marginRight: 8
    },
    uppercase: {
      textTransform: "uppercase"
    },
    commentContent: {
      fontSize: 12,
      color: "#333",
      lineHeight: "17px",
      wordBreak: "break-word"
    },
    additionalSigns: {
      display: "initial"
    },
    colorFOT: {
      color: "#ff6363"
    }
  };
});
